import React from "react";
import ReactPlayer from "react-player";

interface IProps {
  trailers: string[];
}

const MovieTrailers: React.FC<IProps> = ({ trailers }: IProps) => {
  return (
    <React.Fragment>
      {trailers.map((item, index) => (
        <div key={index} className={"player-wrapper"}>
          <ReactPlayer className={"react-player"} url={item} width="100%" height="100%" controls />
        </div>
      ))}
    </React.Fragment>
  );
};

export default MovieTrailers;
